var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import merge from 'lodash.merge';
import { forwardRef } from 'react';
import { StyledTypoggraphy } from './styled';
export var TEXT_HTML_ELEMENTS = {
    a: 'a',
    abbr: 'abbr',
    address: 'address',
    article: 'article',
    aside: 'aside',
    b: 'b',
    bdi: 'bdi',
    bdo: 'bdo',
    blockquote: 'blockquote',
    button: 'button',
    caption: 'caption',
    cite: 'cite',
    code: 'code',
    dd: 'dd',
    del: 'del',
    details: 'details',
    dfn: 'dfn',
    dt: 'dt',
    em: 'em',
    figcaption: 'figcaption',
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    i: 'i',
    ins: 'ins',
    kbd: 'kbd',
    label: 'label',
    legend: 'legend',
    li: 'li',
    mark: 'mark',
    p: 'p',
    pre: 'pre',
    q: 'q',
    s: 's',
    samp: 'samp',
    small: 'small',
    span: 'span',
    strong: 'strong',
    sub: 'sub',
    summary: 'summary',
    sup: 'sup',
    td: 'td',
    th: 'th',
    time: 'time',
    u: 'u',
    var: 'var',
};
export var HTML_ELEMENTS_LIST = Object.keys(TEXT_HTML_ELEMENTS);
var HTML_ELEMENTS_LIST_AS_TAGS = HTML_ELEMENTS_LIST.map(function (x) { return "<".concat(x, ">"); });
var getInvalidElementValueErrorMessage = function (element) {
    return "Invalid HTML element value <".concat(element, "> for the Typography component.\n      Only these elements ").concat(HTML_ELEMENTS_LIST_AS_TAGS.join(', '), " can be used with the Typography component.");
};
export var Typography = forwardRef(function (_a, ref) {
    var _b = _a.element, element = _b === void 0 ? 'span' : _b, _c = _a.as, as = _c === void 0 ? element : _c, children = _a.children, baseSchema = _a.schema, error = _a.error, disabled = _a.disabled, active = _a.active, htmlFor = _a.htmlFor, dataDesign = _a["data-design"], props = __rest(_a, ["element", "as", "children", "schema", "error", "disabled", "active", "htmlFor", 'data-design']);
    var schema = merge({}, baseSchema, { default: props });
    if (!as || !TEXT_HTML_ELEMENTS[as]) {
        throw new Error(getInvalidElementValueErrorMessage(String(as)));
    }
    return (_jsx(StyledTypoggraphy, __assign({ as: as, ref: ref, schema: schema, error: error, disabled: disabled, active: active, htmlFor: htmlFor, "data-design": dataDesign }, props, { children: children })));
});
Typography.displayName = 'Typography';
